export const WHATSAPP_URL = "https://wa.me/19145317603";
export const WHATSAPP_DISPLAY = "+1 914 531 7603";

export const translations = {
  es: {
    nav: { services: "Servicios", offices: "Oficinas", contact: "Contacto", cta: "Solicitar consulta" },
    hero: {
      eyebrow: "Caracas · Nueva York",
      lines: ["Movemos tu", "negocio más allá", "de las fronteras"],
      sub: "Asesoría estratégica, logística integral, importaciones internacionales y transporte ejecutivo entre Venezuela, Estados Unidos y el mundo. Planificamos, dirigimos y ejecutamos.",
      ctaPrimary: "Solicitar consulta",
      ctaSecondary: "WhatsApp directo",
      stats: [
        { value: "VE–US", label: "Presencia binacional" },
        { value: "9+", label: "Líneas de servicio" },
        { value: "ES·EN·PT", label: "Atención trilingüe" },
      ],
    },
    marquee: ["Consultoría Estratégica", "Logística Internacional", "Importaciones Globales", "Transporte Ejecutivo", "Trámites Gubernamentales", "Análisis de Mercado", "Control de Inventario", "Administración de Bienes", "Caracas — Nueva York"],
    services: {
      eyebrow: "Servicios integrales",
      title: "Todo lo que tu operación necesita",
      sub: "De la estrategia a la ejecución: un solo socio para consultoría, logística e importaciones en dos países con alcance global.",
    },
    offices: {
      eyebrow: "Presencia",
      title: "Dos países, una misma precisión",
      sub: "Operamos donde tu negocio lo necesita, con equipos locales en Venezuela y Estados Unidos.",
      caracas: { tag: "Sede Latinoamérica", city: "Caracas", country: "Venezuela", address: "Centro Comercial Concresa, Piso 3, Caracas" },
      croton: { tag: "Sede EE.UU.", city: "Croton-on-Hudson", country: "Nueva York, EE.UU.", address: "17 Bari Mnr, Croton-on-Hudson, NY 10520" },
      cta: "Escribir a esta oficina",
    },
    contact: {
      eyebrow: "Motor de consulta",
      title: "Hablemos de tu operación",
      sub: "Cuéntanos qué necesitas y un asesor te contactará a la brevedad.",
      name: "Nombre completo", namePh: "Tu nombre",
      email: "Correo electrónico", emailPh: "tu@correo.com",
      phone: "Teléfono (opcional)", phonePh: "+58 400 000 0000",
      service: "Servicio de interés",
      message: "Mensaje", messagePh: "Describe brevemente tu necesidad...",
      submit: "Enviar consulta", sending: "Enviando...",
      success: "Consulta recibida. Te contactaremos muy pronto.",
      error: "No pudimos enviar tu consulta. Escríbenos por WhatsApp.",
      other: "Otro / General",
    },
    footer: {
      tagline: "Asesorías integrales, logística internacional e importaciones globales.",
      navTitle: "Navegación",
      contactTitle: "Contacto",
      rights: "© 2026 Sagas Logistic. Todos los derechos reservados.",
    },
    whatsapp_prefill: "Hola Sagas Logistic, quiero una consulta sobre sus servicios.",
  },
  en: {
    nav: { services: "Services", offices: "Offices", contact: "Contact", cta: "Request consultation" },
    hero: {
      eyebrow: "Caracas · New York",
      lines: ["We move your", "business beyond", "borders"],
      sub: "Strategic advisory, integrated logistics, international imports, and executive transport between Venezuela, the United States, and the world. We plan, direct, and execute.",
      ctaPrimary: "Request consultation",
      ctaSecondary: "Direct WhatsApp",
      stats: [
        { value: "VE–US", label: "Binational presence" },
        { value: "9+", label: "Service lines" },
        { value: "ES·EN·PT", label: "Trilingual service" },
      ],
    },
    marquee: ["Strategic Consulting", "International Logistics", "Global Imports", "Executive Transport", "Government Permits", "Market Analysis", "Inventory Control", "Asset Management", "Caracas — New York"],
    services: {
      eyebrow: "Integrated services",
      title: "Everything your operation needs",
      sub: "From strategy to execution: one partner for consulting, logistics, and imports across two countries with global reach.",
    },
    offices: {
      eyebrow: "Presence",
      title: "Two countries, one standard of precision",
      sub: "We operate where your business needs us, with local teams in Venezuela and the United States.",
      caracas: { tag: "Latin America HQ", city: "Caracas", country: "Venezuela", address: "Centro Comercial Concresa, 3rd Floor, Caracas" },
      croton: { tag: "US Headquarters", city: "Croton-on-Hudson", country: "New York, USA", address: "17 Bari Mnr, Croton-on-Hudson, NY 10520" },
      cta: "Message this office",
    },
    contact: {
      eyebrow: "Consultation engine",
      title: "Let's talk about your operation",
      sub: "Tell us what you need and an advisor will reach out shortly.",
      name: "Full name", namePh: "Your name",
      email: "Email address", emailPh: "you@email.com",
      phone: "Phone (optional)", phonePh: "+1 914 000 0000",
      service: "Service of interest",
      message: "Message", messagePh: "Briefly describe your need...",
      submit: "Send inquiry", sending: "Sending...",
      success: "Inquiry received. We'll contact you very soon.",
      error: "We couldn't send your inquiry. Please reach us on WhatsApp.",
      other: "Other / General",
    },
    footer: {
      tagline: "Integrated advisory, international logistics, and global imports.",
      navTitle: "Navigate",
      contactTitle: "Contact",
      rights: "© 2026 Sagas Logistic. All rights reserved.",
    },
    whatsapp_prefill: "Hello Sagas Logistic, I'd like a consultation about your services.",
  },
  pt: {
    nav: { services: "Serviços", offices: "Escritórios", contact: "Contato", cta: "Solicitar consultoria" },
    hero: {
      eyebrow: "Caracas · Nova York",
      lines: ["Movemos o seu", "negócio além", "das fronteiras"],
      sub: "Consultoria estratégica, logística integrada, importações internacionais e transporte executivo entre a Venezuela, os Estados Unidos e o mundo. Planejamos, dirigimos e executamos.",
      ctaPrimary: "Solicitar consultoria",
      ctaSecondary: "WhatsApp direto",
      stats: [
        { value: "VE–US", label: "Presença binacional" },
        { value: "9+", label: "Linhas de serviço" },
        { value: "ES·EN·PT", label: "Atendimento trilíngue" },
      ],
    },
    marquee: ["Consultoria Estratégica", "Logística Internacional", "Importações Globais", "Transporte Executivo", "Tramitações Governamentais", "Análise de Mercado", "Controle de Estoque", "Administração de Bens", "Caracas — Nova York"],
    services: {
      eyebrow: "Serviços integrados",
      title: "Tudo o que a sua operação precisa",
      sub: "Da estratégia à execução: um único parceiro para consultoria, logística e importações em dois países com alcance global.",
    },
    offices: {
      eyebrow: "Presença",
      title: "Dois países, uma mesma precisão",
      sub: "Operamos onde o seu negócio precisa, com equipes locais na Venezuela e nos Estados Unidos.",
      caracas: { tag: "Sede América Latina", city: "Caracas", country: "Venezuela", address: "Centro Comercial Concresa, Piso 3, Caracas" },
      croton: { tag: "Sede EUA", city: "Croton-on-Hudson", country: "Nova York, EUA", address: "17 Bari Mnr, Croton-on-Hudson, NY 10520" },
      cta: "Escrever para este escritório",
    },
    contact: {
      eyebrow: "Motor de consulta",
      title: "Vamos falar sobre a sua operação",
      sub: "Conte-nos o que você precisa e um consultor entrará em contato em breve.",
      name: "Nome completo", namePh: "Seu nome",
      email: "E-mail", emailPh: "voce@email.com",
      phone: "Telefone (opcional)", phonePh: "+1 914 000 0000",
      service: "Serviço de interesse",
      message: "Mensagem", messagePh: "Descreva brevemente a sua necessidade...",
      submit: "Enviar consulta", sending: "Enviando...",
      success: "Consulta recebida. Entraremos em contato em breve.",
      error: "Não foi possível enviar sua consulta. Fale conosco pelo WhatsApp.",
      other: "Outro / Geral",
    },
    footer: {
      tagline: "Assessoria integrada, logística internacional e importações globais.",
      navTitle: "Navegação",
      contactTitle: "Contato",
      rights: "© 2026 Sagas Logistic. Todos os direitos reservados.",
    },
    whatsapp_prefill: "Olá Sagas Logistic, gostaria de uma consultoria sobre seus serviços.",
  },
};
